import styled from "@emotion/styled";

import { StyledSlot as AdslotContainer } from "~/components/advertisement/ad-slots/ad-slot/styles";
import { StoryStyleAdCard } from "~/components/story-style/story-style-layout/story-style-ad-card";

type StoryStyleAdCardProps = {
  $isHidden: boolean;
};
export const StyledStoryStyleAdCard = styled(StoryStyleAdCard)<StoryStyleAdCardProps>`
  display: ${props => (props.$isHidden ? "none" : "flex")};
`;

export const Container = styled.div`
  position: fixed;

  inline-size: 100%;
  block-size: 100vh;

  ${props => props.theme.breakpoints.up("tablet")} {
    position: relative;

    display: grid;
    grid-auto-flow: column;
    place-items: center center;

    padding-block: 5vh;
    padding-inline: 0;

    background-color: #222222;
  }
`;

export const SliderWrapper = styled.div`
  block-size: 100%;

  ${props => props.theme.breakpoints.up("tablet")} {
    position: relative;

    max-inline-size: 740px;
    max-block-size: 1012px;
    padding-block: 0;
    padding-inline: 70px;
    aspect-ratio: 185 / 253;
  }
`;

export const Slides = styled.div`
  position: relative;

  block-size: 100%;

  ${props => props.theme.breakpoints.up("tablet")} {
    border-radius: 20px;
    /* hack to fix this border-radius in safari */
    transform: translateZ(0);

    overflow: hidden;
  }
`;

export const Section = styled.div`
  position: relative;
  inset-block-start: 0;
  inset-inline-start: 0;

  display: flex;
  justify-content: center;

  inline-size: 100%;
  block-size: 100%;
`;

type AdSlotWrapperProps = {
  $isHidden: boolean;
};

export const BottomBannerAdSlotWrapper = styled.div<AdSlotWrapperProps>`
  position: fixed;
  inset-block-end: 16px;
  z-index: 3;

  display: ${props => (props.$isHidden ? "none" : "flex")};

  inline-size: fit-content;

  ${AdslotContainer} {
    justify-content: center;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    position: absolute;
    inset-block-end: 30px;
  }
`;
